import { QueryHookOptions, useQuery } from '@apollo/client';
import gql from 'graphql-tag';

// GraphQL query
const journeyGameBadgeByUserAndGameQuery = gql`
  query GetJourneyGameBadgeByUserAndGame($userId: String!, $gameType: String!) {
    journeyGameBadgeByUserAndGame(userId: $userId, gameType: $gameType) {
      _id
      userId
      gameType
      earnedBadges {
        type
        value
        earnedAt
      }
    }
  }
`;

// Types
export type TEarnedBadge = {
  type: string;
  value?: string;
  earnedAt: string;
};

export type TJourneyGameBadge = {
  _id: string;
  userId: string;
  gameType: string;
  earnedBadges: TEarnedBadge[];
};

export type TQueryJourneyGameBadgeByUserAndGame = {
  journeyGameBadgeByUserAndGame: TJourneyGameBadge | null;
};

// React hook
export function useGetJourneyGameBadgeByUserAndGameQuery(
  options?: QueryHookOptions<
    TQueryJourneyGameBadgeByUserAndGame,
    { userId: string; gameType: string }
  >,
) {
  return useQuery<TQueryJourneyGameBadgeByUserAndGame, { userId: string; gameType: string }>(
    journeyGameBadgeByUserAndGameQuery,
    options,
  );
}
